import { render, staticRenderFns } from "./FastUpdate.vue?vue&type=template&id=fb895888"
import script from "./FastUpdate.vue?vue&type=script&lang=js"
export * from "./FastUpdate.vue?vue&type=script&lang=js"
import style0 from "./FastUpdate.vue?vue&type=style&index=0&id=fb895888&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports